// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Section_container__t7Dfw {
  color: #333333;
}
.Section_container__t7Dfw .Section_margin-title__HZ5Os {
  margin-bottom: 32px;
  margin-top: 40px;
}

.Section_action__BKVit {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.Section_small-title__GoGj0 {
  font-size: 20px;
  font-weight: bold;
}

.Section_medium-title__FuehZ {
  font-size: 24px;
  font-weight: bold;
}

.Section_large-title__6kl0b {
  font-size: 24px;
  font-weight: bold;
}

@media (min-width: 1300px) {
  .Section_large-title__6kl0b {
    font-size: 34px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/common/Section/Section.module.scss","webpack://./src/styles/_colors.scss","webpack://./src/styles/_typography.scss"],"names":[],"mappings":"AAGA;EACE,cCSc;ADXhB;AAIE;EACE,mBAAA;EACA,gBAAA;AAFJ;;AAMA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAHF;;AAMA;EACE,eEfS;EFgBT,iBEbK;AFUP;;AAMA;EACE,eEnBS;EFoBT,iBElBK;AFeP;;AAMA;EACE,eExBS;EFyBT,iBEvBK;AFoBP;;AAMA;EACE;IACE,eE7BO;EF0BT;AACF","sourcesContent":["@use \"styles/typography\";\n@use \"styles/colors\";\n\n.container {\n  color: colors.$color-text-02;\n\n  .margin-title {\n    margin-bottom: 32px;\n    margin-top: 40px;\n  }\n}\n\n.action {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.small-title {\n  font-size: typography.$header-s;\n  font-weight: typography.$bold;\n}\n\n.medium-title {\n  font-size: typography.$header-m;\n  font-weight: typography.$bold;\n}\n\n.large-title {\n  font-size: typography.$header-m;\n  font-weight: typography.$bold;\n}\n\n@media (min-width: 1300px) {\n  .large-title {\n    font-size: typography.$header-l;\n  }\n}\n","$neutral: #333333;\n$neutral-700: #252525;\n$accent: #054ab0;\n$primary: #ff6b00;\n$primary-hover: #c75004;\n$secondary: #1f1f1f;\n$secondary-hover: #393939;\n$default: #666666;\n$light: #616c7a;\n$white: #ffffff;\n$light-blue: #ebf3ff;\n$color-background-02: #f2f2f2;\n$color-background-text: #fbfbfb;\n$color-text-02: #333333;\n$color-text-disabled: #808080;\n$color-button-disabled: #e9e9e9;\n$color-semantic-primary: #e6e6e6;\n$color-success-active: #008863;\n$color-success-disable: #32d2a7;\n$color-error-active: #a63631;\n$color-error-disable: #ff9590;\n$error: #c9423c;\n$text-link: #0058e1;\n$text-link-hover: #003b9c;\n$neutral-200: #696969;\n$error-200: #d73a3d;\n$warning-200: #ffb93c;\n$info-200: #1175c9;\n$success-300: #4ba564;\n$neutral-400: #bbbbbb;\n","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Section_container__t7Dfw`,
	"margin-title": `Section_margin-title__HZ5Os`,
	"action": `Section_action__BKVit`,
	"small-title": `Section_small-title__GoGj0`,
	"medium-title": `Section_medium-title__FuehZ`,
	"large-title": `Section_large-title__6kl0b`
};
export default ___CSS_LOADER_EXPORT___;
